import { isChannelInAnonymousRealm } from './realms'
import { getCustomCommunicationUrl, isEnabled as customCommunicationUrlEnabled } from './customCommunicationUrl'
import { getCustomUrl, isEnabled as customUrlEnabled } from './customUrl'
import selfServiceVideoCommunications from './selfServiceVideoCommunications'
import isReplayEnabled from './replay'
import isProEnabled from './pro'
import { isChannelManagerEnabled, getMaxChannelManagerAllowed } from './managers'
import isSurveysEnabled from './surveys'
import isEmailEnabled from './email'
import { getCustomEmailName, isEnabled as customEmailNameEnabled } from './customEmailName'
import { getCustomEmailAddress, isEnabled as customEmailAddressEnabled } from './customEmailAddress'
import { getEmailOptOutThankyouUrl, isEnabled as emailOptOutThankyouUrlEnabled } from './emailOptOutThankyouUrl'
import { getEmailOptOutErrorUrl, isEnabled as emailOptOutErrorUrlEnabled } from './emailOptOutErrorUrl'
import { getCustomRegistrationTemplate, isEnabled as customRegistrationTemplateEnabled } from './customRegistrationTemplate'
import { getCustomWebcastUrl, isEnabled as customWebcastUrlEnabled } from './customWebcastUrl'
import { getLocale, isEnabled as localeEnabled } from './locale'
import { getNumberOfWebcastsInFirstMonth, isEnabled as numberOfWebcastsInFirstMonthEnabled } from './numberOfWebcastsInFirstMonth'
import { getNumberOfWebcastsPerPeriod, isEnabled as numberOfWebcastsPerPeriodEnabled } from './numberOfWebcastsPerPeriod'
import { getEmailSubscriberBlock, isEnabled as emailSubscriberBlockEnabled } from './emailSubscriberBlock'
import { getMaximumWebcastDuration, isEnabled as maximumWebcastDurationEnabled } from './maximumWebcastDuration'
import { isEnabled as isWebcamTalksEnabled } from './webcamtalk'
import { isEnabled as isAutoCaptionsEnabled } from './autoCaptions'
import isDisableViewingTimeMetrics from './disableViewingTimeMetrics'
import { getBtTokenValueForFastPass, isEnabled as isFastPassEnabled } from './fastPass'
import { isEnabled as isCustomerFastPassEnabled } from './customerFastPass'
import {
  getNurture,
  getNurtureProgramSettings,
  isEnabled as nurtureEnabled,
  isNurtureServiceEnabled,
  isNurtureServiceEnabledForChannel,
  isNurtureProgramEnded,
  formatNurtureProgramDate
} from '../../../../../../apps/central/libs/nurtureFeatures'

export default {
  realms: {
    isChannelInAnonymousRealm
  },
  customCommunicationUrl: {
    isEnabled: customCommunicationUrlEnabled,
    getCustomCommunicationUrl
  },
  customUrl: {
    isEnabled: customUrlEnabled,
    getCustomUrl
  },
  selfServiceVideoCommunications: {
    isEnabled: selfServiceVideoCommunications
  },
  replay: {
    isEnabled: isReplayEnabled
  },
  pro: {
    isEnabled: isProEnabled
  },
  managers: {
    isEnabled: isChannelManagerEnabled,
    getMaxChannelManagerAllowed
  },
  surveys: {
    isEnabled: isSurveysEnabled
  },
  email: {
    isEnabled: isEmailEnabled
  },
  customEmailName: {
    isEnabled: customEmailNameEnabled,
    getCustomEmailName
  },
  customEmailAddress: {
    isEnabled: customEmailAddressEnabled,
    getCustomEmailAddress
  },
  emailOptOutThankyouUrl: {
    isEnabled: emailOptOutThankyouUrlEnabled,
    getEmailOptOutThankyouUrl
  },
  emailOptOutErrorUrl: {
    isEnabled: emailOptOutErrorUrlEnabled,
    getEmailOptOutErrorUrl
  },
  customRegistrationTemplate: {
    isEnabled: customRegistrationTemplateEnabled,
    getCustomRegistrationTemplate
  },
  customWebcastUrl: {
    isEnabled: customWebcastUrlEnabled,
    getCustomWebcastUrl
  },
  locale: {
    isEnabled: localeEnabled,
    getLocale
  },
  numberOfWebcastsInFirstMonth: {
    isEnabled: numberOfWebcastsInFirstMonthEnabled,
    getNumberOfWebcastsInFirstMonth
  },
  numberOfWebcastsPerPeriod: {
    isEnabled: numberOfWebcastsPerPeriodEnabled,
    getNumberOfWebcastsPerPeriod
  },
  emailSubscriberBlock: {
    isEnabled: emailSubscriberBlockEnabled,
    getEmailSubscriberBlock
  },
  maximumWebcastDuration: {
    isEnabled: maximumWebcastDurationEnabled,
    getMaximumWebcastDuration
  },
  webcamtalk: {
    isEnabled: isWebcamTalksEnabled
  },
  disableViewingTimeMetrics: {
    isEnabled: isDisableViewingTimeMetrics
  },
  fastPass: {
    isEnabled: isFastPassEnabled,
    getBtTokenValueForFastPass
  },
  customerFastPass: {
    isEnabled: isCustomerFastPassEnabled
  },
  autoCaptions: {
    isEnabled: isAutoCaptionsEnabled
  },
  nurture: {
    isEnabled: nurtureEnabled,
    getNurture,
    getNurtureProgramSettings,
    isNurtureServiceEnabled,
    isNurtureServiceEnabledForChannel,
    isNurtureProgramEnded,
    formatNurtureProgramDate
  }
}
